import React, { useEffect } from 'react'

import type { EmbedSnippet } from 'utils/marketingEmbeds'

type MarketingEmbedsProps = {
  snippets?: EmbedSnippet[]
}

// Executes the inline scripts marketing flagged with the `evolve-embed` class.
// They arrive already extracted from getStaticProps. We inject fresh <script>
// elements on mount — the dangerouslySetInnerHTML originals in the page content
// are inert and never run — and remove them on unmount. Injecting on mount
// (rather than via next/script, which caches by id and would skip a second
// page's embeds after client-side navigation) runs the snippets on every view.
const MarketingEmbeds: React.FC<MarketingEmbedsProps> = ({ snippets }) => {
  useEffect(() => {
    if (!snippets?.length) return undefined

    const nodes = snippets.map(({ content }) => {
      const el = document.createElement('script')
      el.text = content
      document.body.appendChild(el)
      return el
    })

    return () => nodes.forEach((node) => node.remove())
  }, [snippets])

  return null
}

export default MarketingEmbeds
